/**
 * MDL.make 周辺機器セクション
 * 
 * 概要:
 *   商品ページの保証延長とカートに追加ボタンの間に、
 *   折りたたみ式の周辺機器選択UIを表示する。
 *   商品データはShopifyの「peripheral-devices」コレクションから動的に取得。
 *   カテゴリ分けは商品タグ（peripheral-keyboard, peripheral-mouse 等）で判定。
 * 
 * カート追加:
 *   メインの「カートに追加する」ボタンクリック時に、
 *   選択された周辺機器も /cart/add.js で一緒にカートへ追加。
 * 
 * 設置場所: sections/main-product.liquid の末尾付近に <script src="..."> で読み込み
 */
(function () {
  'use strict';

  // ============================================================
  // 設定
  // ============================================================
  const CONFIG = {
    // コレクションハンドル
    collectionHandle: 'peripheral-devices',

    // カテゴリ定義（表示順序もこの順）
    // tag: 商品に付けるタグ, label: UIに表示するカテゴリ名
    categories: [
      { tag: 'peripheral-keyboard', label: 'キーボード' },
      { tag: 'peripheral-mouse', label: 'マウス' },
      { tag: 'peripheral-headset', label: 'ヘッドセット' },
      { tag: 'peripheral-mousepad', label: 'マウスパッド' },
      { tag: 'peripheral-monitor', label: 'モニター' }
    ],

    // 展開ボタンのテキスト
    toggleLabel: 'デバイス・周辺機器を追加（任意）',

    // デバッグモード
    debug: false
  };

  // ============================================================
  // ユーティリティ
  // ============================================================
  function log(...args) {
    if (CONFIG.debug) console.log('[MDL-Peripheral]', ...args);
  }

  function formatYen(n) {
    return '¥' + n.toLocaleString('ja-JP');
  }

  // ============================================================
  // コレクションから商品取得
  // ============================================================
  async function fetchPeripheralProducts() {
    try {
      const res = await fetch('/collections/' + CONFIG.collectionHandle + '/products.json?limit=250');
      if (!res.ok) {
        log('コレクション取得エラー:', res.status);
        return [];
      }
      const data = await res.json();
      log('取得商品数:', data.products.length);
      return data.products;
    } catch (e) {
      log('コレクション取得失敗:', e);
      return [];
    }
  }

  // ============================================================
  // 商品をカテゴリごとにグルーピング
  // ============================================================
  function groupByCategory(products) {
    const grouped = {};

    CONFIG.categories.forEach(function (cat) {
      grouped[cat.tag] = {
        label: cat.label,
        products: []
      };
    });

    products.forEach(function (product) {
      var tags = Array.isArray(product.tags) ? product.tags : (product.tags ? product.tags.split(', ') : []);
      CONFIG.categories.forEach(function (cat) {
        if (tags.indexOf(cat.tag) !== -1) {
          grouped[cat.tag].products.push(product);
        }
      });
    });

    return grouped;
  }

  // ============================================================
  // UI構築
  // ============================================================
  function buildUI(grouped) {
    // メインコンテナ
    var container = document.createElement('div');
    container.id = 'mdl-peripheral-section';
    container.className = 'mdl-peripheral-section';

    // トグルボタン
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'mdl-peripheral-toggle is-open';
    toggle.innerHTML = '<span class="mdl-peripheral-toggle__chevron">▲</span> ' +
      '<span class="mdl-peripheral-toggle__label">' + CONFIG.toggleLabel + '</span>';

    // コンテンツ（初期非表示）
    var content = document.createElement('div');
    content.className = 'mdl-peripheral-content';
    content.style.display = 'block';

    // トグル動作
    toggle.addEventListener('click', function () {
      var isOpen = content.style.display !== 'none';
      if (isOpen) {
        content.style.display = 'none';
        toggle.querySelector('.mdl-peripheral-toggle__chevron').textContent = '▼';
        toggle.classList.remove('is-open');
      } else {
        content.style.display = 'block';
        toggle.querySelector('.mdl-peripheral-toggle__chevron').textContent = '▲';
        toggle.classList.add('is-open');
      }
    });

    // カテゴリごとにチェックボックスを生成
    var hasProducts = false;

    CONFIG.categories.forEach(function (cat) {
      var catData = grouped[cat.tag];
      if (!catData || catData.products.length === 0) return;

      hasProducts = true;

      var catSection = document.createElement('div');
      catSection.className = 'mdl-peripheral-category';

      // カテゴリラベル
      var catLabel = document.createElement('div');
      catLabel.className = 'mdl-peripheral-category__label';
      catLabel.textContent = catData.label;
      catSection.appendChild(catLabel);

      // 商品リスト
      var list = document.createElement('div');
      list.className = 'mdl-peripheral-category__list';

      catData.products.forEach(function (product) {
        var variant = product.variants[0];
        if (!variant) return;

        var item = document.createElement('div');
        item.className = 'gpo-choicelist gpo-checkbox gpo-ov-item mdl-peripheral-item';

        var inputId = 'mdl-peripheral-' + variant.id;

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.id = inputId;
        input.className = 'mdl-peripheral-checkbox';
        input.dataset.variantId = variant.id;
        input.dataset.price = variant.price;
        input.dataset.productTitle = product.title;

        var label = document.createElement('label');
        label.setAttribute('for', inputId);

        // 商品画像
        if (product.images && product.images.length > 0) {
          var img = document.createElement('img');
          img.className = 'mdl-peripheral-item__img';
          img.src = product.images[0].src.replace(/\.([a-z]+)$/, '_200x200.$1');
          img.alt = product.title;
          img.loading = 'lazy';
          label.appendChild(img);
        }

        // テキスト + 価格のspan
        var valueSpan = document.createElement('span');
        valueSpan.className = 'choicelist-item__value break-word';
        valueSpan.textContent = product.title;

        // 価格表示
        var priceRaw = variant.price;
        var priceNum = parseFloat(priceRaw) || 0;
        log('商品:', product.title, '価格raw:', priceRaw, '価格num:', priceNum);

        if (priceNum > 0) {
          var addOnSpan = document.createElement('span');
          addOnSpan.className = 'addOn';
          addOnSpan.style.marginLeft = '5px';
          addOnSpan.style.display = 'inline';
          addOnSpan.style.color = '#000';
          addOnSpan.textContent = '(+ ' + formatYen(priceNum) + ')';
          valueSpan.appendChild(addOnSpan);
          log('価格span追加完了:', addOnSpan.textContent);
        }

        label.appendChild(valueSpan);

        item.appendChild(input);
        item.appendChild(label);
        list.appendChild(item);
      });

      catSection.appendChild(list);
      content.appendChild(catSection);
    });

    if (!hasProducts) {
      log('表示可能な周辺機器がありません');
      return null;
    }

    container.appendChild(toggle);
    container.appendChild(content);

    return container;
  }

  // ============================================================
  // スタイル注入（Globoのスタイルに合わせる）
  // ============================================================
  function injectStyles() {
    var style = document.createElement('style');
    style.textContent = [
      '/* MDL.make 周辺機器セクション */',
      '.mdl-peripheral-section {',
      '  margin: 16px 0 8px 0;',
      '  font-family: "Open Sans", sans-serif;',
      '}',

      '.mdl-peripheral-toggle {',
      '  display: flex;',
      '  align-items: center;',
      '  width: 100%;',
      '  padding: 12px 0;',
      '  background: none;',
      '  border: none;',
      '  border-top: 1px solid #e0e0e0;',
      '  cursor: pointer;',
      '  font-family: "Open Sans", sans-serif;',
      '  font-size: 14px;',
      '  font-weight: 600;',
      '  color: #000;',
      '  text-align: left;',
      '  transition: color 0.2s;',
      '}',
      '.mdl-peripheral-toggle:hover {',
      '  color: #eb1256;',
      '}',
      '.mdl-peripheral-toggle__chevron {',
      '  font-size: 12px;',
      '  margin-right: 6px;',
      '  color: #eb1256;',
      '  transition: transform 0.2s;',
      '}',

      '.mdl-peripheral-content {',
      '  padding: 4px 0 8px 0;',
      '}',

      '.mdl-peripheral-category {',
      '  margin-bottom: 12px;',
      '}',
      '.mdl-peripheral-category__label {',
      '  font-size: 14px;',
      '  font-weight: 600;',
      '  color: #000;',
      '  margin-bottom: 6px;',
      '  font-family: "Open Sans", sans-serif;',
      '}',

      '.mdl-peripheral-category__list {',
      '  display: flex;',
      '  flex-direction: column;',
      '}',

      '/* Globo のチェックボックススタイルをそのまま利用 */',
      '.mdl-peripheral-item {',
      '  margin-bottom: 2px;',
      '}',
      '.mdl-peripheral-item label {',
      '  display: flex;',
      '  align-items: center;',
      '}',

      '/* 商品画像 */',
      '.mdl-peripheral-item__img {',
      '  width: 90px;',
      '  height: 90px;',
      '  object-fit: cover;',
      '  border-radius: 4px;',
      '  margin-right: 8px;',
      '  flex-shrink: 0;',
      '}',

      '/* 価格表示（Globoと同じ） */',
      '.mdl-peripheral-item .addOn {',
      '  margin-left: 5px;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  // ============================================================
  // カート追加のフック
  // ============================================================
  var bypassHook = false;

  function hookCartButton() {
    // capture フェーズでクリックを先にキャッチ
    document.addEventListener('click', function (e) {
      // 再発火時はスルー
      if (bypassHook) return;

      var btn = e.target.closest('.gpo-clone-atc-button, .gpo-original-atc-button, .product-form__submit');
      if (!btn) return;

      var selectedItems = getSelectedPeripherals();
      if (selectedItems.length === 0) return;

      // Globo のハンドラを止める
      e.preventDefault();
      e.stopImmediatePropagation();

      log('クリック停止、周辺機器を先に追加:', selectedItems);

      // 周辺機器を先にカートに追加 → 完了後にGloboのクリックを再発火
      addPeripheralsToCart(selectedItems).then(function () {
        log('周辺機器追加完了、Globoのクリックを再発火');
        bypassHook = true;
        btn.click();
        bypassHook = false;
      });
    }, true);

    log('カートボタンにフック完了');
  }

  function getSelectedPeripherals() {
    var checkboxes = document.querySelectorAll('.mdl-peripheral-checkbox:checked');
    var items = [];
    checkboxes.forEach(function (cb) {
      items.push({
        id: parseInt(cb.dataset.variantId, 10),
        quantity: 1,
        properties: {
          '_peripheral': 'true'
        }
      });
    });
    return items;
  }

  async function addPeripheralsToCart(items) {
    try {
      for (var i = 0; i < items.length; i++) {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: items[i].id,
            quantity: items[i].quantity,
            properties: items[i].properties
          })
        });

        if (!res.ok) {
          log('カート追加エラー:', items[i], res.status);
        } else {
          log('カート追加成功:', items[i].id);
        }
      }
    } catch (e) {
      log('カート追加失敗:', e);
    }
  }

  // ============================================================
  // DOM挿入
  // ============================================================
  function insertUI(sectionEl) {
    // 挿入位置: gpo-container の後、product-form の前
    var gpoContainer = document.querySelector('.gpo-container');
    var productForm = document.querySelector('product-form');

    if (gpoContainer && productForm) {
      productForm.parentNode.insertBefore(sectionEl, productForm);
      log('UIをGloboコンテナの後に挿入しました');
      return true;
    }

    // フォールバック: カートボタンの直前
    var atcBtn = document.querySelector('.product-form__submit');
    if (atcBtn) {
      var formEl = atcBtn.closest('form') || atcBtn.parentNode;
      formEl.parentNode.insertBefore(sectionEl, formEl);
      log('UIをフォームの前に挿入しました（フォールバック）');
      return true;
    }

    log('挿入位置が見つかりません');
    return false;
  }

  // ============================================================
  // 初期化
  // ============================================================
  async function init() {
    log('初期化開始');

    // Globoの描画を待つ
    var gpoApp = document.querySelector('.gpo-app');
    if (!gpoApp) {
      log('Globo要素未検出、500ms後にリトライ...');
      setTimeout(init, 500);
      return;
    }

    // スタイル注入
    injectStyles();

    // コレクションから商品取得
    var products = await fetchPeripheralProducts();
    if (products.length === 0) {
      log('周辺機器商品がありません。終了。');
      return;
    }

    // カテゴリ分け
    var grouped = groupByCategory(products);

    // UI構築
    var sectionEl = buildUI(grouped);
    if (!sectionEl) return;

    // DOM挿入
    var inserted = insertUI(sectionEl);
    if (!inserted) return;

    // カートボタンにフック
    hookCartButton();

    log('初期化完了');
  }

  // ============================================================
  // エントリーポイント
  // ============================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 800);
    });
  } else {
    setTimeout(init, 800);
  }

})();